import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Company } from "./data-contracts";

export const getCurrentUser = (params?: IFetchConfig) =>
  fetch<{
    user: string;
    role: string[];
    user_id: number;
    company: Company;
  }>("GET", `current_user`, null, params);
